<script>
let estadosDefault = {
  0: 'Creado',
  10: 'Cotización',
  20: 'Proyecto aprobado',
  30: 'Producido',
  40: 'Empacado',
  50: 'Entrega',
  100: 'Nota de venta'
}
export default {
  mapaDefault: () => {
    return estadosDefault
  },
  mapeo: (num) => {
    return estadosDefault[num] || ''
  }
}
</script>
